import React from 'react';
import { motion } from 'framer-motion';
import './visit.css';

function Visit() {
  return (
    <div className="visit-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6 }} 
            className="visit-title"
          >
            Explore Our Campus
          </motion.h1>
          <p className="hero-subtitle">
            Join us for a virtual or in-person tour to experience our vibrant community, facilities, and academic spaces.
          </p>
          <a href="#tour" className="hero-button">
            Start Tour
          </a>
        </div>
      </div>

      {/* Tour Timeline */}
      <section id="tour" className="tour-section">
        <div className="tour-container">
          <h2 className="section-title">Campus Tour Highlights</h2>
          <div className="tour-items">
            {[
              { title: "Welcome Center", desc: "Start your journey at our Welcome Center where friendly staff will guide you through the experience.", image: "/banner1.jpg" },
              { title: "Library", desc: "Explore our modern library with thousands of resources and peaceful study areas.", image: "/library.jpeg" },
              { title: "Science Labs", desc: "Visit cutting-edge laboratories equipped for practical and research-based learning.", image: "/lab.jpeg" },
              { title: "Sports Complex", desc: "Check out our world-class sports complex with indoor and outdoor facilities.", image: "/sport.jpeg" },
              { title: "Student Housing", desc: "Take a look at our comfortable, modern dormitories and student living spaces.", image: "/innovative.jpeg" },
            ].map((stop, i) => (
              <motion.div 
                key={i} 
                className={`tour-item ${i % 2 === 0 ? 'reverse' : ''}`}
                initial={{ opacity: 0, x: i % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img src={stop.image} alt={stop.title} className="tour-image" />
                <div className="tour-text">
                  <h3>{stop.title}</h3>
                  <p>{stop.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="testimonials-container">
          <h2 className="section-title">What Visitors Say</h2>
          <div className="testimonials-grid">
            {[
              { name: "Alex Fernando", comment: "The campus is stunning and the tour was well-organized. It felt like home!" },
              { name: "Dilani Perera", comment: "Loved the library and student spaces. The guide was super helpful and friendly!" },
            ].map((t, i) => (
              <motion.div 
                key={i}
                className="testimonial"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4 }}
                viewport={{ once: true }}
              >
                <p>"{t.comment}"</p>
                <span>- {t.name}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="map-section">
        <div className="map-container">
          <h2 className="section-title">Find Us on the Map</h2>
          <div className="map-frame">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.7513034374824!2d79.86938077448274!3d6.920306318426057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259744a1d7131%3A0x614fbd9988cf7417!2sEye%20Care%20Institute!5e0!3m2!1sen!2slk!4v1749122164452!5m2!1sen!2slk" 
              width="100%"
              height="400"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Campus Map"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Visit;
